import { ChevronDown } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useLanguage } from "@/hooks/useLanguage";
import { getRouteKeyFromPath, getTranslatedUrl, type Language } from "@/lib/route-mapping";

const LanguageSwitcher = () => {
  const { language } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();

  const languages = [
    { code: 'en', name: 'English' },
    { code: 'es', name: 'Español' },
    { code: 'vi', name: 'Tiếng Việt' },
  ];

  const currentLanguage = languages.find(lang => lang.code === language);

  const handleLanguageChange = (newLang: Language) => {
    // Get current route key
    const routeKey = getRouteKeyFromPath(location.pathname);
    
    if (routeKey) {
      // Navigate to translated URL
      const translatedUrl = getTranslatedUrl(routeKey, newLang);
      navigate(translatedUrl);
    } else {
      // Fallback for unmapped routes
      const newPath = newLang === 'en' 
        ? location.pathname.replace(/^\/(es|vi)/, '') || '/'
        : `/${newLang}${location.pathname.replace(/^\/(es|vi)/, '')}`;
      navigate(newPath);
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-2">
          <span className="font-medium">{currentLanguage?.name}</span>
          <ChevronDown className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {languages.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => handleLanguageChange(lang.code as Language)}
            className="cursor-pointer"
          >
            <span className={language === lang.code ? 'font-semibold' : ''}>{lang.name}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSwitcher;